import { useStorageObject } from "../../app/state/storageObjectSlice/hook/use-storage-object";
import { useServiceNavigate } from "../../app/state/storageObjectSlice/hook/use-service-navigate";
import { Sidebar } from "../../common/AppSidebar";
import { SafeOutlet } from "../../common/Protectors/SafeOutlet";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";
import styles from "./styles.module.css";

export const PracticumPage = () => {
  const { menuItems, selectedObject, isLoading, currentService } =
    useStorageSelectors("practicum");
  const { handleSelectObject } = useStorageObject(
    "practicum",
    "practicum",
    currentService,
  );

  useServiceNavigate("practicum", "practicum");

  return (
    <div className={styles["page-layout"]}>
      <Sidebar
        menuItems={menuItems}
        onSelect={handleSelectObject}
        selectedId={selectedObject?.id ?? ""}
        service={"practicum"}
        title={"Практикум"}
        isLoading={isLoading ?? false}
        withoutActions
      />
      {selectedObject && <SafeOutlet />}
    </div>
  );
};
